<template>
    <div 
    class="cardContainer"
    :style="isShowDetails ? { 
        borderColor: activityStatus == 1 ? '#36d8365e' : (activityStatus == 2 || activityStatus == 3) ? '#e2675f80' : activityStatus == 0 ? '#2196f380' : 'transparent',
        boxShadow: activityStatus == 1 
            ? '0 0 10px #36d83660' 
            : (activityStatus == 2 || activityStatus == 3) 
            ? '0 0 10px #ff000060' 
            : activityStatus == 0 
            ? '0 0 10px #2196f360' 
            : 'none'
    } : { border: 'none', boxShadow: 'none' }"
>
        <van-row v-if="isShowDetails">
            <van-col span="12" class="dayImageColumn">
                <div class="dayImage">
                    <img v-if="activityStatus == 0" src="@/assets/lossFunds/pending.png" alt="">
                    <img v-if="activityStatus == 1" src="@/assets/lossFunds/success.png" alt="">
                    <img v-if="activityStatus == 2 || activityStatus == 3" src="@/assets/lossFunds/cancel.png" alt="">
                    <span class="main-date">{{ createTime?.split(' ')[0] }}</span>
                </div>
                
            </van-col>
            <van-col span="12" class="statusColumn">
            <div  :class="activityStatus == 0 ? 'pending' : activityStatus == 1 ? 'completed' : 'no-rewards'" v-if="dayList?.length <= 0 || !dayList">
                <div v-if="props.activityStatus == 0 && (dayList?.length <= 0 || !dayList)" class="pending">
                    <van-icon name="clock-o" class="status-icon" />
                    <span>{{ $t('activityStatus.pending') }}</span>
                </div>

                <div v-else-if="props.activityStatus == 1 && (dayList?.length <= 0 || !dayList)" class="completed">
                    <van-icon name="checked" class="status-icon" />
                    <span>{{ $t('activityStatus.completed') }}</span>
                </div>

                <div v-else-if="(props.activityStatus == 2 || props.activityStatus == 3) && (dayList?.length <= 0 || !dayList)" class="no-rewards">
                     <van-icon name="warn-o" class="status-icon" />
                    <span>{{ props.activityStatus == 2 ? $t('activityStatus.noRewards') : $t('activity.overdue') }}</span>
                </div>
            </div>
        </van-col>
          <van-row class="totalRow">
            <van-col span="12" class="topRow" style="margin: 10px 0;">
                <div class="dayTitle">{{ title }}</div>
                <div class="valueText" :style="{ color: statusColor }">{{ formatCurrency(totalAmount) }}</div>
            </van-col>
            <van-col span="12" class="topRow" style="margin: 10px 0;">
                <div class="dayTitle">{{ $t('activity.cashBackTotal') }}</div>
                <div class="valueText" :style="{ color: statusColor }">{{ dayList ? formatCurrency(getAmountSum(dayList)) : formatCurrency(0) }}</div>
            </van-col>
        </van-row>
       </van-row> 
        <van-row 
        v-if="!isShowDetails" 
        class="historyCard"
        >
        <van-col span="4" class="dayColumn">
            <div class="dayImage2">
                <img src="@/assets/lossFunds/history_cal.png" alt="">
            </div>
        </van-col>

        <van-col span="7" class="infoColumn">
            <div class="dateText2">{{ createTime?.split(' ')[0] }}</div>
            <div class="subText">{{ $t('activity.givenAmount') }}</div>
        </van-col>

        <van-col span="4" class="amountColumn">
            {{ formatCurrency(givenAmount) }}
        </van-col>

        <van-col span="9" class="statusColumn">
        <div  :class="activityStatus == 0 ? 'pending' : activityStatus == 1 ? 'completed' : 'no-rewards'" v-if="dayList?.length <= 0 || !dayList">
                <div v-if="props.activityStatus == 0 && (dayList?.length <= 0 || !dayList)" class="pending">
                    <van-icon name="clock-o" class="status-icon" />
                    <span>{{ $t('activityStatus.pending') }}</span>
                </div>

                <div v-else-if="props.activityStatus == 1 && (dayList?.length <= 0 || !dayList)" class="completed">
                    <van-icon name="checked" class="status-icon" />
                    <span>{{ $t('activityStatus.completed') }}</span>
                </div>

                <div v-else-if="(props.activityStatus == 2 || props.activityStatus == 3) && (dayList?.length <= 0 || !dayList)" class="no-rewards">
                     <van-icon name="warn-o" class="status-icon" />
                    <span>{{ props.activityStatus == 2 ? $t('activityStatus.noRewards') : $t('activity.overdue') }}</span>
                </div>
            </div>
    </van-col>
   </van-row>
        <van-row v-if="isShowDetails && dayList?.length > 0 || !dayList" justify="center">
            <van-col span="24" class="collapse-header" @click="toggleCollapse">
                <span>{{ $t('activity.detalhamento') }}</span>
                <van-icon :name="isCollapsed ? 'arrow-down' : 'arrow-up'" class="arrow-icon" />
            </van-col>
        </van-row>
        <van-row v-if="isShowDetails && !isCollapsed" style="margin-top: 10px; display: flex; justify-content: center; gap: 5px;"
            justify="space-between">
            <van-col span="4" v-for="(i, index) in dayList" :key="index">
                <!-- <div 
                class="dayCard"
                :style="getDayCardStyle(i.date)"
                > -->
                <div 
                class="dayCard"
                  >
                    <div class="dayTitleIsShow">{{ dayFormat(i.date, 0) }}</div>
                    <div>{{ formatCurrency(i.amount) }}</div>
                </div>
            </van-col>{{ }}
            <van-col v-if="dayList?.length <= 0 || !dayList">
            </van-col>
        </van-row>
    </div>
</template>
<script lang="ts" setup>
import { checkDate, dayFormat, formatCurrency, } from '@/utils/commonFunction';
import { getAmountSum } from '@/view/components/supportFunction';
import { PropType, } from 'vue';
import { ref, computed} from 'vue';

const props = defineProps({
    dayCount: {
        type: Number,
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    createTime: {
        type: String,
        default: () => ""
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    title: {
        type: String,
        default: () => ""
    },
    totalAmount: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    isShowDetails: {
        type: Boolean,
        default: () => true
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
})

const getDayCardStyle = (date: string) => {
  const status = checkDate(date);

  if (status === 0 && props.istodayClaimed) {
    return {
      color: '#36d836',
      border: '1px solid #36d836',
      boxShadow: '0 0 6px #36d83680',
      borderRadius: '10px',
      padding: '4px'
    };
  }

  if (status < 0) {
    return {
      color: 'gray',
      border: '1px solid #666',
      borderRadius: '10px',
      padding: '4px'
    };
  }

  if (status > 0) {
    return {
      color: '#fff',
      border: '1px solid #fff',
      borderRadius: '10px',
      padding: '4px'
    };
  }

  return {};
};

const isCollapsed = ref(true); 

const toggleCollapse = () => {
    isCollapsed.value = !isCollapsed.value;
};

const statusColor = computed(() => {
  if (props.activityStatus === 1) return '#36d836';
  if (props.activityStatus === 2 || props.activityStatus === 3) return '#e2675f';
  if (props.activityStatus === 0) return '#2196f3';
  return '';
});

</script>
<style scoped>
.cardContainer {
    background: #39261c82;
    border: 0.5px solid transparent; 
    border-radius: 15px;
    padding: 10px 10px;
    color: #fff;
    font-size: 12px;
    margin: 10px 0 0;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
}
.status-badge-container {
  position: absolute;
  top: 12px;
  right: 12px;
}

.status-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 20px; 
  font-size: 14px;
  font-weight: 600;
  color: #000; 
}

.collapse-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 10px 0;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    color: #edededbf
}

.arrow-icon {
    font-size: 12px;
    transition: transform 0.3s ease;
}

.topRow {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.dayColumn {
    /* display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center; */
}

.statusColumn {
    display: flex;
    justify-content: flex-end;
    text-align: center;
    align-items: center;
}

.totalRow{
    width: 100%;
}

.dayImageColumn {
   display: flex;
   flex-direction: column;
   /* justify-content: center; */
    text-align: center;
    /* align-items: center;  */
}

.right-texts {
    text-align: center;
    display: flex;
}

.day-num {
    position: absolute;
    font-size: 20px;
    white-space: nowrap;
    color: #FFF5D7;
    text-shadow: -1px -1px 0 #300000, 1px -1px 0 #300000, -1px 1px 0 #300000, 1px 1px 0 #300000;
    z-index: 800;
    font-weight: 700;
    left: 55%;
    top: 25%;
}

.dateText {
    position: absolute;
    top: 50%;
    padding: 5px 0;
    font-size: 6px;
    color: #000;
    font-weight: 600;
}

.dayImage img {
    width: 5vh;
    padding: 0 0 5px;
    position: relative;
}

.dayImage {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    gap: 8px;
}

.dayImage2 img {
    width: 40px;
}

/* .dayImage2 {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
} */
/* Middle text */
.infoColumn {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.dateText2 {
    font-size: clamp(0.95rem, 0.85rem + 0.15vw, 1rem);
    font-weight: 600;
    color: #fff;
}

.subText {
    font-size: clamp(0.6875rem, 0.65rem + 0.2vw, 0.8125rem);
    color: #aaa;
}

/* Amount */
.amountColumn {
    font-size: clamp(1.125rem, 1.08rem + 0.22vw, 1.3125rem);
    font-weight: 700;
    display: flex;
    align-items: center;
    color: #F8D6BA
    /* text-align: right; */
}

/* Status pill */
.status-pill {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    text-align: center;
}

/* Colors */
.status-pill.pending {
    background: #d9ecff;
    color: #0484ff;
}

.status-pill.success {
    background: #d4f8d4;
    color: #36d836;
}

.status-pill.danger {
    background: #ffd6d6;
    color: #ff4d4f;
}
.centerAlignment {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.dayCard {
    font-size: 9.5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px 0;
    min-width: 13%;
    /* border-radius: 6px;
    border: 1px solid transparent; */
    transition: all 0.3s ease;
    color: '#fff';
    border: 1px solid #ffffffb4;
    border-radius: 10px;
    padding: 5px;
}

.dayCardWrapper {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    flex: 1;
}

.dayCardWrapper::-webkit-scrollbar {
    display: none;
}

.scrollRow {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    gap: 5px;
}

.arrowLeft img {
    width: 10px;
}

.arrowRight {
    position: absolute;
    right: 0px;
}

.arrowLeft {
    position: absolute;
    left: 0px;
}

.arrowRight img {
    width: 10px;
    transform: rotate(180deg);
}

.dayTitle {
    /* font-weight: bold; */
    padding-bottom: 5px;
    font-size: 14px;
}

.dayTitleIsShow {
    font-weight: bold;
    padding-bottom: 5px;
}

.rightBorder {
    border-right: 1px solid #80808070;
}

.click_btn {
    color: #12151A;
    font-size: 11.5px;
    background-image: linear-gradient(rgb(248, 216, 167) 0%, rgb(240, 168, 83) 100%);
    border-radius: 5px;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 50%;
}

.valueText {
    padding: 2px 0 5px;
    font-size: 18px;
    font-weight: 700;
}

.bottomDayRow {
    display: flex;
    flex-direction: row;
}

.status-badge-wrapper{
    padding: 7px;
    border-radius: 7px;
}

.completed,
.pending,
.no-rewards {
  padding: 3px;
  border-radius: 7px;
  color: #000;
  font-weight: 600;
  display: flex;
  gap: 4px;
  /* border: 1px solid rgba(255, 255, 255, 0.4); */
}

.completed {
  background-color: #36d836;
  box-shadow: 0 0 6px rgba(54, 216, 54, 0.6);
}

.pending {
  background-color: #0484ff;
  box-shadow: 0 0 6px rgba(4, 132, 255, 0.6);
}

.no-rewards {
  background-color: #E2675F;
  box-shadow: 0 0 6px rgba(226, 103, 95, 0.6);
}

.status-icon {
  font-size: 15px;
}

@media (min-width:350px) {
    .dateText {
        font-size: 8px;
    }
}

@media (min-width:450px) {
    .dateText {
        font-size: 11px;
    }
}

@media (min-width: 600px) {
    .dateText {
        font-size: 10px;
    }
}

@media (min-width: 1920px) {
    .dateText {
        font-size: 14px;
    }
}
</style>